export default {
	init() {
		if (document.querySelector('#toc-shortcode')) {
			let id = 0;
			const ul = document.querySelector('#toc-shortcode ul#toc-links');
			const links = document.querySelectorAll('.article-body h2');

			for (const link of links) {
				id++;
				link.setAttribute("id", `toc-${id}`);
				ul.innerHTML += `<li><a href="#toc-${id}"> ${link.innerText}</a></li>`;
			}
		}
	}
};
